import { isEqual, sortBy } from 'lodash';

/** Order-insensitive match: groups and items within each group compared as sets. */
export function areMatcherEqual(
  expected: string[][],
  result?: string[][],
): boolean {
  if (!Array.isArray(result)) return false;
  if (expected.length !== result.length) return false;

  const normalize = (groups: string[][]): string[][] =>
    sortBy(groups.map(g => sortBy(g)), g => g.join('|'));

  return isEqual(normalize(expected), normalize(result));
}
